/**
 * iam(ceRouter) 中仅 EE 存在的安全建议菜单
 */
import Layout from '@/layouts/RouterView'
import i18n from '@/locales'
import { featureMenuHiddenCheck } from '@/utils/auth'
import { isScopedPolicyMenuHidden } from '@/utils/scopedPolicy'

const SuggestsAlert = () => import(/* webpackChunkName: "subscription" */ /* webpackPrefetch: true */ '@Bill/views/suggestsalert')
const SuggestsRule = () => import(/* webpackChunkName: "subscription" */ /* webpackPrefetch: true */ '@Bill/views/suggestionrule')
const SuggestsRuleConfig = () => import(/* webpackChunkName: "subscription" */ /* webpackPrefetch: true */ '@Bill/views/suggestsysruleconfig')

function menuPath (path) {
  return '/iam' + path
}

export const securitySuggestMenu = {
  meta: {
    label: i18n.t('scope.text_960'),
  },
  subGroup: 'security',
  submenus: [
    {
      path: menuPath('/suggestsysalert'),
      meta: {
        label: i18n.t('meter.security_suggestion_list'),
        permission: 'suggestsysalerts_list',
        hidden: (userInfo, menu) => {
          if (isScopedPolicyMenuHidden('sub_hidden_menus.iam_suggestsysalert')) {
            return true
          }
          return featureMenuHiddenCheck(menu)
        },
      },
      component: Layout,
      children: [
        {
          name: 'SecuritySuggestsAlert',
          path: '',
          component: SuggestsAlert,
          props: { title: i18n.t('meter.security_suggestion_list') },
        },
      ],
    },
    {
      path: menuPath('/suggestsysruleconfig'),
      meta: {
        label: i18n.t('meter.security_ignore_list'),
        permission: 'suggestsysruleconfigs_list',
        hidden: (userInfo, menu) => {
          if (isScopedPolicyMenuHidden('sub_hidden_menus.iam_suggestsysruleconfig')) {
            return true
          }
          return featureMenuHiddenCheck(menu)
        },
      },
      component: Layout,
      children: [
        {
          name: 'SecuritySuggestsRuleConfig',
          path: '',
          component: SuggestsRuleConfig,
          props: { title: i18n.t('meter.security_ignore_list') },
        },
      ],
    },
    {
      path: menuPath('/suggestsysrule'),
      meta: {
        label: i18n.t('meter.security_rule_setting'),
        permission: 'suggestsysrules_list',
        hidden: (userInfo, menu) => {
          if (isScopedPolicyMenuHidden('sub_hidden_menus.iam_suggestsysrule')) {
            return true
          }
          return featureMenuHiddenCheck(menu)
        },
      },
      component: Layout,
      children: [
        {
          name: 'SecuritySuggestsRule',
          path: '',
          component: SuggestsRule,
          props: { title: i18n.t('meter.security_rule_setting') },
        },
      ],
    },
  ],
}
